var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Brian test page","icon":"mdi-account-multiple"}})
}
var staticRenderFns = []

export { render, staticRenderFns }